import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { getFetcher } from 'api/swr'
import React from 'react'
import { useLocation } from 'react-router-dom'

const AuthLayout = ({ title, description, children, showOAuth = true }) => {
  const location = useLocation()
  
  const handleOAuthLogin = async () => {
    try {
      // 先尝试从 sessionStorage 读取，如果没有再从 location.state 获取
      const savedRedirect = sessionStorage.getItem('oauth_redirect')
      const from = savedRedirect || location.state?.from?.pathname || '/personal'
      
      // 保存登录前的页面位置到 sessionStorage
      sessionStorage.setItem('oauth_redirect', from)
      console.log('Saving redirect target before OAuth:', from)
      
      const data = await getFetcher('/oauth/url')
      if (data.url) {
        window.location.href = data.url
      }
    } catch (error) {
      console.error('Failed to get OAuth login URL:', error)
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <div className="flex flex-col lg:flex-row gap-6 max-w-5xl w-full">
        {/* 左侧：表单内容 */}
        <Card className="flex-1 w-full lg:w-auto">
          <CardHeader>
            <CardTitle className="text-2xl">{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </CardHeader>
          <CardContent>{children}</CardContent>
        </Card>

        {/* 右侧：OAuth 登录 */}
        {showOAuth && (
          <Card className="flex-1 flex flex-col w-full lg:w-auto lg:min-w-[400px]">
            <CardHeader>
              <CardTitle className="text-2xl">快速登录</CardTitle>
              <CardDescription>
                使用 OAuth2.0 快速登录 NeKu for designer
              </CardDescription>
            </CardHeader>
            <CardContent className="flex-1 flex items-center justify-center py-8">
              <Button
                type="button"
                onClick={handleOAuthLogin}
                className="w-full max-w-xs bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white shadow-lg"
                size="lg"
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                  />
                </svg>
                OAuth2.0 登录
              </Button>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  )
}

export default AuthLayout
